<span
  #origin="cdkOverlayOrigin"
  cdkOverlayOrigin
  id="menu-overflow"
  class="flex-container flex-align-center menu-item nav"
  tabindex="0"
  role="button"
  aria-haspopup="menu"
  [attr.aria-expanded]="isOpen$ | async"
  [attr.aria-label]="TranslationKeys.MenuMore | translate"
  [class.menu-item-active]="active"
  (mouseenter)="open()"
  (click)="open()"
  (keydown.enter)="toggleByKeyboard($event)"
  (keydown.space)="toggleByKeyboard($event)"
>
  <nimbus-icon
    class="warning"
    [icon]="Icons.ELLIPSIS_H"
    [markIcon]="Icons.EXCLAMATION_TRIANGLE"
    [marked]="hasUserPreferencesNotification"
  ></nimbus-icon>
</span>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayPanelClass="menu-overlay"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayPositions]="connectedPositions"
  [cdkConnectedOverlayOpen]="isOpen$ | async"
  (attach)="overlayAttached()"
  (detach)="overlayDetached()"
  (overlayOutsideClick)="close()"
  (overlayKeydown)="onOverlayKeydown($event)"
  (positionChange)="onPositionChange($event)"
>
  <div class="menu-overlay-container">
    <div class="menu-multiple-item-overlay-callout" [class.menu-overflow-callout-bottom]="opensUpwards$ | async"></div>
    <ul role="menu" [attr.aria-label]="TranslationKeys.MenuMore | translate">
      @for (entry of entries; track entry.name) {
        <ng-container *ngTemplateOutlet="overflowEntry; context: { entry: entry, subEntry: false }"></ng-container>
        @for (subEntry of entry.subEntries; track subEntry.name) {
          @if (subEntry.filter$ | async) {
            <ng-container *ngTemplateOutlet="overflowEntry; context: { entry: subEntry, subEntry: true }"></ng-container>
          }
        }
        @if (entry.renderAs === MenuEntryType.Companion && (isSplitScreenEnabled$ | async)) {
          <li class="sub-entry" role="none">
            <div
              id="menu-overflow-companion-full-screen"
              class="flex-container flex-align-center-left menu-overlay-item menu-overflow-sub-item"
              role="menuitem"
              tabindex="0"
              (click)="navigate(entry)"
              (keydown.enter)="navigate(entry)"
            >
              <i [nimbusIcon]="Icons.COMPANION"></i>
              <span>{{ TranslationKeys.CompanionChatFullScreen | icuTranslate }}</span>
            </div>
          </li>
          <li class="sub-entry" role="none">
            <div
              id="menu-overflow-companion-split-screen"
              class="flex-container flex-align-center-left menu-overlay-item menu-overflow-sub-item"
              role="menuitem"
              tabindex="0"
              (click)="navigateCompanionSplitScreen()"
              (keydown.enter)="navigateCompanionSplitScreen()"
            >
              <i [nimbusIcon]="Icons.COLUMNS"></i>
              <span>{{ TranslationKeys.CompanionChatSplitScreen | icuTranslate }}</span>
            </div>
          </li>
        }
      }
    </ul>
  </div>
</ng-template>

<ng-template #overflowEntry let-entry="entry" let-subEntry="subEntry">
  <li class="sub-entry" role="none">
    <div
      class="flex-container flex-align-center-left menu-overlay-item"
      role="menuitem"
      tabindex="0"
      [id]="'menu-overflow-entry-' + entry.name"
      [class.menu-overflow-sub-item]="subEntry"
      (click)="navigate(entry)"
      (keydown.enter)="navigate(entry)"
    >
      @let customImageUrl = entry.customImageUrl$ | async;
      @if (entry.renderAs === MenuEntryType.UserPreferences) {
        <nimbus-icon
          class="warning"
          [icon]="entry.icon"
          [markIcon]="Icons.EXCLAMATION_TRIANGLE"
          [marked]="hasPermissionNotification"
        ></nimbus-icon>
      } @else if (customImageUrl) {
        <img class="menu-item-custom-icon" [src]="customImageUrl" [alt]="entry.name | icuTranslate" />
      } @else {
        <i [nimbusIcon]="entry.icon"></i>
      }
      <span>{{ (entry.customTooltip$ | async) || (entry.name | icuTranslate) }}</span>
      @if (entry.indicator) {
        @if ({ displayed: entry.indicator.displayed$ | async, displayedCount: entry.indicator.displayedCount$ | async }; as indicator) {
          @if (indicator.displayed) {
            <span class="menu-overflow-indicator" [class]="entry.indicator.class">
              @if (entry.indicator.icon) {
                <i [nimbusIcon]="entry.indicator.icon"></i>
              }
              @if (indicator.displayedCount) {
                {{ indicator.displayedCount }}
              }
            </span>
          }
        }
      }
    </div>
  </li>
</ng-template>
